<template>
  <div class="w-[300px] overflow-y-auto text-[#333333]">
    <fulfillment-resume-row
      label="Fulfillment Fee"
      :value="totalFulfillmentFee"
    />
    <fulfillment-resume-row
      v-if="status === 'submitted'"
      label="Upgrade Fullfillment"
      :value="upgradedFulfillment"
    />
    <fulfillment-resume-row
      v-if="status === 'submitted'"
      label="Selisih"
      :value="fulfillmentFeeDifference"
    />
  </div>
</template>

<script>
import FulfillmentResumeRow from './FulfillmentResumeRow.vue'

export default {
  name: 'FulfillmentResume',
  components: {
    FulfillmentResumeRow,
  },
  props: {
    status: {
      type: String,
      required: false,
      default: 'submitted',
    },
    totalFulfillmentFee: {
      type: Number,
      required: false,
      default: 0,
    },
    totalOrder: {
      type: Number,
      required: false,
      default: 0,
    },
    upgradeFulfillment: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    fulfillmentFeeDifference() {
      return this.upgradeFulfillment - this.totalFulfillmentFee
    },
    upgradedFulfillment() {
      return this.upgradeFulfillment === this.totalFulfillmentFee ? 0 : this.upgradeFulfillment
    },
  },
}
</script>
